var map = {
	"./avatar/default-csob.png": 91498,
	"./avatar/default-jtbank.png": 56851,
	"./avatar/default-prgaero.png": 17309,
	"./avatar/default-tmobile.png": 85593,
	"./avatar/default.png": 82580,
	"./avatar/presets/avatar-1.svg": 16970,
	"./avatar/presets/avatar-10.svg": 92822,
	"./avatar/presets/avatar-11.svg": 79943,
	"./avatar/presets/avatar-12.svg": 8436,
	"./avatar/presets/avatar-13.svg": 34069,
	"./avatar/presets/avatar-14.svg": 23658,
	"./avatar/presets/avatar-15.svg": 41499,
	"./avatar/presets/avatar-16.svg": 60136,
	"./avatar/presets/avatar-17.svg": 68057,
	"./avatar/presets/avatar-18.svg": 6686,
	"./avatar/presets/avatar-19.svg": 69263,
	"./avatar/presets/avatar-2.svg": 91993,
	"./avatar/presets/avatar-20.svg": 52299,
	"./avatar/presets/avatar-21.svg": 47034,
	"./avatar/presets/avatar-22.svg": 88969,
	"./avatar/presets/avatar-23.svg": 13464,
	"./avatar/presets/avatar-24.svg": 8535,
	"./avatar/presets/avatar-25.svg": 45734,
	"./avatar/presets/avatar-26.svg": 81957,
	"./avatar/presets/avatar-27.svg": 3940,
	"./avatar/presets/avatar-28.svg": 94067,
	"./avatar/presets/avatar-29.svg": 63490,
	"./avatar/presets/avatar-3.svg": 26600,
	"./avatar/presets/avatar-30.svg": 18024,
	"./avatar/presets/avatar-31.svg": 99769,
	"./avatar/presets/avatar-4.svg": 15783,
	"./avatar/presets/avatar-5.svg": 51958,
	"./avatar/presets/avatar-6.svg": 23829,
	"./avatar/presets/avatar-7.svg": 51220,
	"./avatar/presets/avatar-8.svg": 84355,
	"./avatar/presets/avatar-9.svg": 69714,
	"./chatbot/avatar.svg": 40681,
	"./chatbot/sarah-avatar-dark.svg": 94120,
	"./chatbot/sarah-avatar-light.svg": 57064,
	"./chatbot/tina-avatar-dark.svg": 60095,
	"./chatbot/tina-avatar-light.svg": 50877,
	"./chatbot/tina-bubble-1.png": 22274,
	"./chatbot/tina-bubble-1.svg": 6765,
	"./chatbot/tina-bubble-2.png": 78361,
	"./chatbot/tina-bubble-2.svg": 23790,
	"./chatbot/tina-error.png": 8782,
	"./chatbot/tina-login.png": 36383,
	"./dashboard/dashboard-diary-empty.svg": 54657,
	"./dashboard/dashboard-diary-finished.svg": 22992,
	"./dashboard/dashboard-diary-unfinished.svg": 71577,
	"./dashboard/dashboard-discussion-empty.svg": 32232,
	"./dashboard/dashboard-discussion-finished.svg": 24511,
	"./dashboard/dashboard-discussion-unfinished.svg": 57574,
	"./dashboard/dashboard-task-empty.svg": 52751,
	"./dashboard/dashboard-task-finished.svg": 67870,
	"./dashboard/dashboard-task-unfinished.svg": 5179,
	"./diary/diaries-hero.png": 96815,
	"./diary/diaries-hero.svg": 33440,
	"./diary/echo-diary.png": 79764,
	"./discussion/discussion-hero.png": 64177,
	"./discussion/discussion-hero.svg": 49942,
	"./emoji/01.svg": 42490,
	"./emoji/02.svg": 84425,
	"./emoji/03.svg": 8920,
	"./emoji/04.svg": 3991,
	"./emoji/05.svg": 41190,
	"./emoji/06.svg": 77413,
	"./emoji/07.svg": 99396,
	"./emoji/08.svg": 89523,
	"./emoji/09.svg": 58946,
	"./emoji/10.svg": 13480,
	"./emoji/11.svg": 95225,
	"./emoji/12.svg": 52874,
	"./favicon/apple-touch-icon.png": 79358,
	"./favicon/favicon-48x48.png": 66683,
	"./favicon/favicon.ico": 73458,
	"./favicon/favicon.svg": 33099,
	"./favicon/web-app-manifest-192x192.png": 51183,
	"./favicon/web-app-manifest-512x512.png": 53799,
	"./flags/bg_BG.svg": 54951,
	"./flags/cs_CZ.svg": 71316,
	"./flags/de_DE.svg": 88607,
	"./flags/en_EN.svg": 44919,
	"./flags/hu_HU.svg": 93111,
	"./flags/no_NO.svg": 21223,
	"./flags/pl_PL.svg": 19217,
	"./flags/ro_RO.svg": 83367,
	"./flags/sk_SK.svg": 12461,
	"./flags/th_TH.svg": 47865,
	"./ilustration.svg": 42926,
	"./medals/1-off.png": 14109,
	"./medals/1.png": 88557,
	"./medals/2-off.png": 70682,
	"./medals/2.png": 6934,
	"./medals/3-off.png": 20739,
	"./medals/3.png": 3263,
	"./medals/4-off.png": 24168,
	"./medals/4.png": 51936,
	"./medals/5-off.png": 91017,
	"./medals/5.png": 6761,
	"./messages/finished-task.svg": 68831,
	"./messages/reward-pickup.svg": 18433,
	"./people.jpg": 30392,
	"./premium/chart.png": 12091,
	"./premium/check-circle-green.svg": 47759,
	"./premium/highlighting.png": 48235,
	"./premium/page-separator-1.png": 83930,
	"./premium/page-separator-1.svg": 55349,
	"./premium/page-separator-2.png": 88689,
	"./premium/page-separator-2.svg": 42390,
	"./premium/respondents.png": 78370,
	"./premium/tagging-positive.png": 45912,
	"./premium/tagging.png": 2466,
	"./project-backgrounds/bg-144.png": 11416,
	"./project-backgrounds/bg-214.png": 25052,
	"./project-backgrounds/bg-281.png": 29810,
	"./project-backgrounds/bg-282.png": 94953,
	"./project-backgrounds/bg-356.png": 98223,
	"./project-backgrounds/bg-575.png": 94752,
	"./project-backgrounds/bg-681.png": 26790,
	"./project-backgrounds/bg-682.png": 7997,
	"./project-backgrounds/bg-696.png": 42994,
	"./project-backgrounds/bg-697.png": 64539,
	"./project-backgrounds/bg-699.png": 72149,
	"./project-backgrounds/bg-722.png": 22110,
	"./project-backgrounds/bg-740.png": 28938,
	"./project-backgrounds/bg-799.svg": 91751,
	"./project-backgrounds/bg-800.svg": 99566,
	"./project-backgrounds/bg-801.svg": 14207,
	"./project-backgrounds/bg-881.svg": 80039,
	"./project-backgrounds/bg-919.png": 59826,
	"./project-backgrounds/bg-konzulat.png": 14947,
	"./project-backgrounds/bg-rb.png": 21289,
	"./project-backgrounds/illustration.svg": 66966,
	"./project/default-csob.png": 38426,
	"./project/default-jtbank.png": 60579,
	"./project/default-prgaero.png": 38893,
	"./project/default-tmobile.png": 55241,
	"./project/default.png": 29572,
	"./spinner.gif": 88845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38139;